import { createSaga } from './saga-helpers';

import * as Api from '../api/subteams-api';

const watchGetSubteams = createSaga({
    type: 'SUBTEAMS_FETCH',
    fn: Api.fetchSubteams,
    args: action => [action.payload],
    successPayload: ({ subteams, hasMore } = {}, action) => ({
        subteams,
        hasMore,
        ...action.payload
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        ...action.payload
    })
});

const watchCreateSubteam = createSaga({
    type: 'SUBTEAM_CREATE',
    fn: Api.createSubteam,
    args: action => [action.payload.subteam],
    successPayload: (subteam, action) => ({
        subteamId: subteam.id,
        fragment: action.payload.subteam,
        subteam: {
            id: subteam.id
        }
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        fragment: action.payload.subteam
    })
});

const watchGetSubteam = createSaga({
    type: 'SUBTEAM_FETCH',
    fn: Api.fetchSubteam,
    args: action => [action.payload.subteamId],
    successPayload: subteam => ({ subteam }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        subteamId: action.payload.subteamId
    })
});

const watchUpdateSubteam = createSaga({
    type: 'SUBTEAM_UPDATE',
    fn: Api.updateSubteam,
    args: action => [action.payload.subteamId, action.payload.subteamProps],
    successPayload: subteam => ({ subteam })
});

const watchRemoveSubteam = createSaga({
    type: 'SUBTEAM_REMOVE',
    fn: Api.removeSubteam,
    args: action => [action.payload.subteamId, action.payload.removeOptions],
    successPayload: (e, action) => ({
        subteamId: action.payload.subteamId
    })
});

const watchTransferSubteam = createSaga({
    type: 'SUBTEAM_TRANSFER',
    fn: Api.transferSubteam,
    args: action => [action.payload.subteamId, action.payload.userId]
});

const watchLeaveSubteam = createSaga({
    type: 'SUBTEAM_LEAVE',
    fn: Api.leaveSubteam,
    args: action => [action.payload.subteamId]
});

const watchAddSubteamMembers = createSaga({
    type: 'SUBTEAM_ADD_MEMBERS',
    fn: Api.addSubteamMembers,
    args: action => [action.payload.subteamId, action.payload.users],
    successPayload: (response, action) => ({
        subteamId: action.payload.subteamId,
        users: action.payload.users
    })
});

const watchRemoveSubteamMembers = createSaga({
    type: 'SUBTEAM_REMOVE_MEMBERS',
    fn: Api.removeSubteamMembers,
    args: action => [action.payload.subteamId, action.payload.users],
    successPayload: (response, action) => ({
        subteamId: action.payload.subteamId,
        users: action.payload.users
    })
});

export default [watchGetSubteams, watchCreateSubteam, watchGetSubteam, watchUpdateSubteam, watchRemoveSubteam, watchTransferSubteam, watchLeaveSubteam, watchAddSubteamMembers, watchRemoveSubteamMembers];
